import axios from "axios";
import { showErrorMessage } from "./utils";
const BaseURL = process.env.REACT_APP_BASE_URL

const schoolServices = {

    getSchoolProfile() {
        return new Promise(async (resolve, reject) => {

            try {
                const resp = await axios.get(`${BaseURL}school/profile`);
                resolve(resp.data)
            } catch (err) {
                showErrorMessage({ message: "There is some network/server issue" })
                reject(err)
            }

        })
    },
    getStudentUnderProgram(data,query="") {
        return new Promise(async (resolve, reject) => {

            try {
                console.log(data, "<-- data")
                let resp
                if (data.year && data.month) {
                    resp = await axios.get(`${BaseURL}school/getStuAccToSchProg?school_id=${data.schoolId}&program_id=${data.programId}&month=${data.month}&year=${data.year}`);
                }
                else {
                    resp = await axios.get(`${BaseURL}school/getStuAccToSchProg?school_id=${data.schoolId}&program_id=${data.programId}${query}`)
                }

                resolve(resp.data)
            } catch (err) {
                reject(err)
            }

        })
    },

    // ---------------------------------------20 Dec-----------------------------------------
    getAdministrativeFiles(data, query = "") {    ///Administrative Files
        return new Promise(async (resolve, reject) => {

            try {
                const resp = await axios.get(`${BaseURL}school/getSharedFolderAndFiles?school_id=${data}${query}`);
                resolve(resp.data)
            } catch (err) {
                reject(err)
            }

        })
    },
    getSharedDoc(Docdetails) {
        return new Promise(async (resolve, reject) => {

            try {
                const resp = await axios.post(`${BaseURL}school/get/document `, Docdetails);
                resolve(resp)
            } catch (err) {
                reject(err)
            }

        })
    },
    getSharedFilesUnderFolder(folderId) {
        return new Promise(async (resolve, reject) => {

            try {
                const resp = await axios.get(`${BaseURL}school/getSharedFolder/${folderId}`);
                resolve(resp)
            } catch (err) {
                reject(err)
            }

        })
    },
    MakereqForRotation(ReqData) {
        return new Promise(async (resolve, reject) => {

            try {
                const resp = await axios.post(`${BaseURL}school/addRotationRequest`, ReqData);
                resolve(resp)
            } catch (err) {
                reject(err)
            }

        })
    },
    getAllRotationReq(ReqData) {
        return new Promise(async (resolve, reject) => {

            try {
                let resp
                if (ReqData.RotationDate) {
                    resp = await axios.get(`${BaseURL}school/getRotationRequests?school_id=${ReqData.schoolId}&date=${ReqData.RotationDate}`);
                }
                else {
                    resp = await axios.get(`${BaseURL}school/getRotationRequests?school_id=${ReqData.schoolId}`);
                }

                resolve(resp)
            } catch (err) {
                reject(err)
            }

        })
    },

    getRotationsDprtmnts(ReqData) {
        return new Promise(async (resolve, reject) => {

            try {
                const resp = await axios.get(`${BaseURL}school/getDepartments`);
                resolve(resp)
            } catch (err) {
                reject(err)
            }

        })
    },
    getHospitalList(ReqData) {
        return new Promise(async (resolve, reject) => {

            try {
                const resp = await axios.get(`${BaseURL}school/getHospitals`);
                resolve(resp)
            } catch (err) {
                reject(err)
            }

        })
    },
    getBatchStudentlist(reqId) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.get(`${BaseURL}school/getStudent?school_id=${reqId.school_id}&program_id=${reqId.program_id}`);
                resolve(resp)
            } catch (err) {
                reject(err)
            }
        })
    },
    UpdateRotationDetails(reqData) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post(`${BaseURL}school/addRequestDetail`, reqData);
                resolve(resp)
            } catch (err) {
                reject(err)
            }
        })
    },
    createFileFolder(reqData) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post(`${BaseURL}school/addSchoolCustom`, reqData);
                resolve(resp)
            } catch (err) {
                reject(err)
            }
        })
    },
    getFileFolder(reqData, query="") {  //my files api  own created 
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.get(`${BaseURL}school/getSchoolCustom?createdBy_id=${reqData}${query}`);
                resolve(resp)
            } catch (err) {
                reject(err)
            }
        })
    },
    deleteFileFolder(reqData) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`${BaseURL}school/deleteFolderFiles?id=${reqData.id}&type=${reqData.type}`);
                resolve(resp)
            } catch (err) {
                reject(err)
            }
        })
    },
    getRegSchools(reqData) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.get(`${BaseURL}school/college/list`);
                resolve(resp)
            } catch (err) {
                reject(err)
            }
        })
    },
    shareSchoolFolders(reqData) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post(`${BaseURL}school/share/documents`, reqData);
                resolve(resp)
            } catch (err) {
                reject(err)
            }
        })
    },

    getSignaturedDocs(reqData, reqname = "") {   //______________________student contract
        return new Promise(async (resolve, reject) => {
            try {
                if (reqData === "folder") {
                    const resp = await axios.get(`${BaseURL}school/getSharedSignedDocs?type=${reqData}${reqname}`);
                    resolve(resp)
                }
                else {
                    const resp = await axios.get(`${BaseURL}school/getSharedSignedDocs?school_id=${reqData}${reqname}`);
                    resolve(resp)
                }

            } catch (err) {
                reject(err)
            }
        })
    },
}

export default schoolServices